import { cn } from "@/design-system/lib/utils";

interface Props {
  outcome: string | null | undefined;
  className?: string;
}

const TONE_MAP: Record<string, string> = {
  Connected: "text-status-success border-status-success/40 bg-status-success/10",
  "No Answer": "text-gray-mid border-border-light bg-white-warm",
  Voicemail: "text-gold-shadow border-gold-shadow/40 bg-gold-shadow/10",
  Busy: "text-status-warning border-status-warning/40 bg-status-warning/10",
  Bounced: "text-status-error border-status-error/40 bg-status-error/10",
};

/**
 * Call / Voicemail / Email outcome chip. Tone defaults to a neutral
 * border when no explicit mapping exists so unknown server-side
 * outcomes still render legibly.
 */
export function OutcomeBadge({ outcome, className }: Props) {
  if (!outcome) return null;
  const tone =
    TONE_MAP[outcome] ?? "text-gray-mid border-border-light bg-white-warm";
  return (
    <span
      className={cn(
        "inline-flex items-center px-space-2 py-[2px] rounded-pill border",
        "font-display text-[10px] font-bold uppercase tracking-[0.12em]",
        tone,
        className,
      )}
    >
      {outcome}
    </span>
  );
}
